import React from "react";
import EventIcons from "./EventIcons";

const PSPCDetails = ({ eventDetails, text }) => {
  return (
    <>
      <div
        style={{
          width: "10%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <EventIcons
          icon={
            <p
              style={{
                fontWeight: "700",
                color: "white",
                padding: "0 5px",
              }}
            >
              {text}
            </p>
          }
        />
      </div>
      <div
        style={{
          width: "35%",
        }}
      >
        <span
          style={{
            marginRight: 5,
          }}
        >
          {eventDetails?.playerSelected?.playerNumber}
        </span>
        <span style={{}}>{eventDetails?.playerSelected?.playerName}</span>
      </div>
      <div
        style={{
          width: "15%",
        }}
      >
        <span style={{}}>{eventDetails?.sideSelected?.teamName}</span>
      </div>
    </>
  );
};

export default PSPCDetails;
